import React from 'react';
import ProgressButton from 'components/confirmation/progressButton/ProgressButton';
import { ConfirmationButtonsType } from 'hooks/useConfirmationContent/types';
import { ANALYTICS_ID } from '../../../../constants';

export const ConfirmationButtons: React.FC<ConfirmationButtonsType> =
  ({
    duration, startText, endText, text = '', link
  }) => {
    return (
      <ProgressButton
        id={ANALYTICS_ID.BUTTON_ACCESS_SOFTWARE}
        startText={startText || text}
        endText={endText || text}
        duration={duration || 0}
        href={link}
      />
    );
  };
